import { CountriesType } from '../components/language-selector/CountriesType';

export const ListDNIForCountry = {
	[CountriesType.BR]: {
		CNPJ: 'CNPJ',
		CPF: 'CPF',
	},
	[CountriesType.CO]: {
		RUT: 'RUT',
		CC: 'CC',
	},
	[CountriesType.MX]: {
		CURP: 'CURP',
		RFC: 'RFC',
	},
};
